import { RefObject, useEffect, useRef } from 'react';

export const useHeightObserver = <T extends HTMLElement>(onResize?: () => void): RefObject<T> => {
    const ref = useRef<T>(null);
    const previousHeight = useRef<number | null>(null);

    useEffect(() => {
        if (!ref.current || typeof ResizeObserver === 'undefined') return;

        const observer = new ResizeObserver(([entry]) => {
            const { height } = entry.contentRect;
            if (height !== previousHeight.current) {
                previousHeight.current = height;

                onResize?.();
            }
        });

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, [onResize]);

    return ref;
};
